export enum GenderEnum {
    Male = 'M',
    Female = 'F',
    Other = 'O'
}
